import { Link } from 'react-router-dom';

const milestones = [
  { year: '1975', title: 'Kuruluş', desc: 'Töle Lojistik, Türkiye\'de küçük bir nakliye firması olarak kuruldu.' },
  { year: '1990', title: 'Avrupa\'ya Açılış', desc: 'Almanya hattı açıldı, ilk uluslararası seferler başladı.' },
  { year: '2005', title: 'İkinci Nesil', desc: 'Baba\'nın kurduğu firma, oğlunun liderliğiyle büyümeye devam etti.' },
  { year: '2024', title: 'Bugün', desc: '27 Avrupa ülkesine hizmet, 500+ mutlu müşteri, aynı aile değerleri.' },
];

const strengths = [
  {
    icon: 'ri-home-heart-line',
    title: 'Ev Taşıma Uzmanı',
    desc: 'Türkiye\'nin her ilinden Avrupa\'nın her ülkesine anahtar teslim ev taşıma. Paketlemeden kuruluma her şey dahil.',
    highlight: true,
  },
  {
    icon: 'ri-box-3-line',
    title: 'Parsiyel Taşımacılık',
    desc: 'Küçük yükler için büyük çözüm. Sadece yüklediğiniz kadar ödeyin, haftalık düzenli seferlerle Avrupa\'ya ulaşın.',
    highlight: true,
  },
  {
    icon: 'ri-truck-line',
    title: 'Kargo Taşımacılığı',
    desc: 'Bireysel kargolardan ticari yüklere kadar her boyutta güvenli, hızlı ve sigortalı kargo hizmeti.',
    highlight: true,
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-20 md:py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">

        {/* Top: Aile Firması Tanıtımı */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20">

          {/* Sol: Görsel */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden h-[420px] md:h-[500px]">
              <img
                src="/media/37cab922-2a40-4787-8594-1f16c7157304_aaaa-4721fa0f9c.png"
                alt="Töle Lojistik - 50 Yıllık Aile Firması"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

              {/* Floating badge */}
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white/95 rounded-xl p-4 flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-brand-orange/10 text-brand-orange rounded-xl flex-shrink-0">
                    <i className="ri-award-line text-2xl"></i>
                  </div>
                  <div>
                    <div className="text-brand-navy font-heading font-bold text-lg leading-none">50 Yıllık</div>
                    <div className="text-gray-500 text-sm mt-0.5">Güven ve Deneyim</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-brand-orange font-heading font-bold text-2xl">1975</div>
                    <div className="text-gray-400 text-xs">Kuruluş Yılı</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative stat card */}
            <div className="absolute -top-5 -right-5 bg-brand-navy text-white rounded-2xl p-5 hidden md:block">
              <div className="text-3xl font-heading font-bold text-brand-orange">500+</div>
              <div className="text-white/70 text-xs mt-1">Mutlu Müşteri</div>
            </div>
          </div>

          {/* Sağ: İçerik */}
          <div>
            <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-4">Biz Kimiz?</p>
            <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl leading-tight mb-6">
              50 Yıldır Aynı Güven,
              <br />
              <span className="text-brand-orange">Baba'dan Oğula Miras</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-5">
              1975 yılında kurulan Töle Lojistik, yarım asrı aşkın süredir aynı değerlerle hizmet veriyor: <strong className="text-brand-navy">dürüstlük, güven ve aile sorumluluğu.</strong>
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              Bugün baba-oğul ortaklığıyla yönetilen firmamız, Türkiye'nin 81 ilinden Avrupa'nın 27 ülkesine ev taşıma, parsiyel ve kargo taşımacılığında sektörün en güvenilir ismi olmaya devam ediyor. Her geçen gün büyüyen müşteri ailemiz, bize duyulan güvenin en büyük kanıtı.
            </p>

            {/* Değerler */}
            <div className="grid grid-cols-3 gap-4 mb-8">
              {[
                { icon: 'ri-heart-line', label: 'Aile Değerleri' },
                { icon: 'ri-shield-check-line', label: 'Güven & Şeffaflık' },
                { icon: 'ri-user-add-line', label: 'Büyüyen Müşteri Kitlesi' },
              ].map((v) => (
                <div key={v.label} className="text-center p-4 rounded-xl bg-gray-50 border border-gray-100">
                  <div className="w-10 h-10 flex items-center justify-center bg-brand-orange/10 text-brand-orange rounded-lg mx-auto mb-2">
                    <i className={`${v.icon} text-xl`}></i>
                  </div>
                  <div className="text-brand-navy text-xs font-semibold leading-tight">{v.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://wa.me/905322376576?text=Merhaba%2C%20bilgi%20almak%20istiyorum."
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-brand-orange hover:bg-orange-600 text-white px-6 py-3 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-base"></i>
                </span>
                Hemen İletişime Geç
              </a>
              <Link
                to="/neden-biz"
                className="inline-flex items-center justify-center gap-2 border border-gray-200 text-brand-navy hover:border-brand-orange hover:text-brand-orange px-6 py-3 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-base"></i>
                </span>
                Neden Biz?
              </Link>
            </div>
          </div>
        </div>

        {/* Zaman Çizelgesi */}
        <div className="mb-20">
          <div className="text-center mb-10">
            <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Tarihçemiz</p>
            <h3 className="text-brand-navy font-heading font-bold text-2xl md:text-3xl">50 Yıllık Yolculuk</h3>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {milestones.map((m, i) => (
              <div key={m.year} className="relative">
                <div className={`rounded-2xl p-6 h-full border transition-all duration-300 hover:-translate-y-1 ${i === milestones.length - 1 ? 'bg-brand-navy border-brand-navy text-white' : 'bg-gray-50 border-gray-100'}`}>
                  <div className={`text-2xl font-heading font-bold mb-2 ${i === milestones.length - 1 ? 'text-brand-orange' : 'text-brand-orange'}`}>{m.year}</div>
                  <div className={`font-heading font-bold text-base mb-2 ${i === milestones.length - 1 ? 'text-white' : 'text-brand-navy'}`}>{m.title}</div>
                  <p className={`text-sm leading-relaxed ${i === milestones.length - 1 ? 'text-white/60' : 'text-gray-400'}`}>{m.desc}</p>
                </div>
                {i < milestones.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-2 w-4 h-0.5 bg-gray-200 z-10"></div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Güçlü Olduğumuz Alanlar */}
        <div>
          <div className="text-center mb-10">
            <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Uzmanlık Alanlarımız</p>
            <h3 className="text-brand-navy font-heading font-bold text-2xl md:text-3xl">Öne Çıkan Hizmetlerimiz</h3>
            <p className="text-gray-400 text-sm mt-3 max-w-lg mx-auto">Yarım asrı aşkın tecrübemiz ve büyüyen müşteri ailemizle bu alanlarda fark yaratıyoruz.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {strengths.map((s) => (
              <div
                key={s.title}
                className="relative rounded-2xl p-7 border-2 border-brand-orange/20 bg-gradient-to-br from-brand-orange/5 to-transparent hover:border-brand-orange/40 transition-all duration-300 hover:-translate-y-1 group"
              >
                <div className="absolute top-4 right-4 w-2 h-2 rounded-full bg-brand-orange animate-pulse"></div>
                <div className="w-14 h-14 flex items-center justify-center bg-brand-orange text-white rounded-xl mb-5 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${s.icon} text-2xl`}></i>
                </div>
                <h4 className="text-brand-navy font-heading font-bold text-lg mb-3">{s.title}</h4>
                <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
